import NoticeInput from "../../components/Recruiting/Notice/NoticeInput";

export default function NoticeNew({ mode }) {
  return (
    <NoticeInput
      existingHtmlStr={""}
      existingTitle={""}
      id={null}
      mode={mode}
      exisistingDeadline={""}
      existingTags={[]}
    />
  );
}
